export default __webpack_public_path__ + "static/media/no-saved-filters.8691660f.svg";